import { render, staticRenderFns } from "./PublicPond.vue?vue&type=template&id=20c401d8&scoped=true"
import script from "./PublicPond.vue?vue&type=script&lang=js"
export * from "./PublicPond.vue?vue&type=script&lang=js"
import style0 from "./PublicPond.vue?vue&type=style&index=0&id=20c401d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c401d8",
  null
  
)

export default component.exports